module.exports = __webpack_public_path__ + "static/img/ic_x_s_fo.d064a1da.svg";